module.exports = __webpack_public_path__ + "img/12.12267433.jpeg";